// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SectionTitle-module--wrap--jMcvM","title":"SectionTitle-module--title--1zlJK"};